import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da3f7670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tips" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, " 本场考试已开启防切屏限制，切换页面10次后将进行强行交卷，请勿切屏及刷新页面！ ", -1))
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("我已清楚")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_button, {
        round: "",
        color: "#50212F",
        size: "large",
        onClick: _ctx.clear
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}